import { unifiedApi } from "@/lib/unified-api";

export function useCompanyQuery(companyId: string) {
  return unifiedApi.useSuspenseQuery("get", "/v1/companies/{id}", {
    params: {
      path: {
        id: companyId,
      },
    },
  });
}
